import React from "react";
import { BOOKING_STATUS, PAYMENT_STATUS } from "@/lib/bookingConstants";

export function PaymentBadge({ status }) {
  const s = PAYMENT_STATUS[status] || PAYMENT_STATUS.UNPAID;
  return (
    <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-bold tracking-wide ${s.cls}`} data-testid={`payment-badge-${status}`}>
      {s.label.toUpperCase()}
    </span>
  );
}

export function BookingStatusBadge({ status }) {
  const s = BOOKING_STATUS[status] || BOOKING_STATUS.CONFIRMED;
  return (
    <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-bold tracking-wide ${s.cls}`} data-testid={`status-badge-${status}`}>
      {s.label.toUpperCase()}
    </span>
  );
}

// Backwards-compatible alias used by the dashboard timeline.
export const ProgressBadge = BookingStatusBadge;
